module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-7-8acdb7d002c96852a6776047e3dbe727.jpg";